import { Component, Inject } from '@angular/core'
import { MatCard } from '@angular/material/card'
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatButton, MatIconButton } from '@angular/material/button'
import { Clipboard } from '@angular/cdk/clipboard'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'

@Component({
  selector: 'dialog-to-choose',
  imports: [MatCard, MatDialogClose, MatIcon, MatButton, MatIconButton],
  templateUrl: './dialog-to-choose.component.html',
  styleUrl: './dialog-to-choose.component.scss',
})
export class DialogChooseComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private snackbar: SnackbarCustomService,
  ) {}

  copyMessage(): void {
    if (this.data?.copyText && this.clipboard.copy(this.data.copyText)) {
      this.snackbar.success('Mensagem copiada para a área de transferência.')
    }
  }
}
